import { render, staticRenderFns } from "./Bando26Fase5.vue?vue&type=template&id=2f7412af&scoped=true"
import script from "./Bando26Fase5.vue?vue&type=script&lang=js"
export * from "./Bando26Fase5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7412af",
  null
  
)

export default component.exports